// window.Cookies = require("js-cookie")
var componentRequireContext = require.context("components/shop", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)
